<template>
    <div class="aboutUs">
        <div class="pic">
            <img src="../assets/img/about－bg.png" alt="">
        </div>
        <main class="aboutUs-main">
            <el-tabs type="border-card" v-model="activeName" tabPosition="left" @tab-click="handleClick">
                <el-tab-pane label="橙蟹简介" name="cxjj" class="intro">
                    <h3>橙蟹介绍</h3>
                    <p>橙蟹是一家互联网财务咨询服务公司，专注于第三方规范财务的服务平台，是企业主身边的一站式财务咨询及落地专家。通过创新财务产品与服务的持续开发，组织最专业的财务资源，全方位去解决企业成长过程中各阶段的问题，控制财务风险，促进企业合规与发展。</p>
                    <p>橙蟹顾问团队均来自于会计师事务所、各行各业优秀企业的财务职业人，以知识培训、财务核算、预算管控、税务辅导及团队激励为切入点，深度挖掘数据价值，坚持以真实的财务数据和纯粹客观的第三方视角出发，为企业在不同时期提供定制化财务解决方案，并通过培训、外派、顾问及猎头等服务，解决中小微企业成长过程中各阶段问题。</p>
                    <p>橙蟹于2018年创立财务顾问合伙人平台，作为链接中小微企业与顾问之间的桥梁。帮助财务人转型为财务顾问，实现专业价值化、时间自由、收入自由，同时蜕变为具有财务专业能力和业务能力的独立财务顾问。</p>
                    <h3>橙蟹大事件</h3>
                    <div class="bigNew">
                        <img src="../assets/img/about－image－1.png" alt="">
                    </div>

                    <h3>企业文化</h3>
                    <div class="culture">
                        <div>愿景:致力服务于中小微企业及企业主,成为类似“ 国际四大”的合伙品牌</div>
                        <div>使命：聚集财务数据、规范财务标准、践行专业价值</div>
                        <div>价值观: 真文化、人平等、事透明</div>
                        <div>服务宗旨:销售即交付、交付即销售</div>
                    </div>

                    <!-- <h3>背景介绍</h3>
                    <p>橙蟹企服，是深圳市云石企业服务有限公司（以下简称“云石企业”）旗下品牌服务商， 于2015年1月8日正式成立。</p>
                    <div class="bgIntro">
                        <div>
                            <img src="../assets/img/about－image－2.png" alt="">
                        </div>
                        <div>
                            <img src="../assets/img/about－image－3.png" alt="">
                        </div>
                        <div>
                            <img src="../assets/img/about－image－4.png" alt="">
                        </div>
                    </div> -->
                </el-tab-pane>

                <el-tab-pane label="橙蟹优势" name="cxys" class="advantage">
                    <div class="selectCX clearfix">
                        <div class="fl"><img src="../assets/img/about－image－5.jpg" alt=""></div>
                        <div class="fr word">
                            <h3>为什么要选择橙蟹？</h3>
                            <p>创始人石金文先生作为有使命感的会计人，放弃了会计师事务所高薪职位，带着改变行业现状的初衷，与志同道合的财务团队一起联合创办了橙蟹。橙蟹创始团队均来自前四大会计师事务所资深成员，多年深耕于企业财税服务领域。</p>
                        </div>
                    </div>

                    <h2>我们经验丰富<p>已服务企业数量3000+</p>
                    </h2>
                    <div class="jyPic">
                        <img src="../assets/img/about－image－6.png" alt="">
                    </div>

                    <h2>客户口碑<p>用实力说话</p>
                    </h2>
                    <div class="praise">
                        <el-row>
                            <el-col class="praiseBox" :span="7" v-for="(item,i) in praiseList" :key="i">
                                <div>
                                    <img :src="item.imgPath" alt="">
                                </div>
                                <div>{{item.word}}</div>
                            </el-col>
                        </el-row>
                    </div>
                </el-tab-pane>

                <el-tab-pane label="企业资讯" name="qyzx" class="information">
                    <el-row v-for="item in informationList" :key="item.companyNewsId" class="information-row">
                        <el-col :span="6">
                            <div class="information-row-img" @click="jump(item.companyNewsId)">
                                <img :src="url+item.companyNewsImg" alt="">
                            </div>
                        </el-col>
                        <el-col :span="18" class="rel">
                            <div class="information-row-word" @click="jump(item.companyNewsId)">
                                <h4>{{item.title}}</h4>
                                <p>{{item.description}}</p>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="14" style="height:1px;">
                        </el-col>
                        <el-col :span="10">
                            <el-pagination small background layout="prev, pager, next" :current-page="paging.pageNum" @current-change="handleCurrentChange" @prev-click="prevClickChange" @next-click="nextClickChange" :total="paging.total">
                            </el-pagination>
                        </el-col>
                    </el-row>

                </el-tab-pane>

                <el-tab-pane label="加入我们" name="jrwm" class="join">
                    <h2>投递简历至：hr@orancrab.com</h2>
                    <div class="formTop">
                        <el-row>
                            <el-col :span="8">
                                <div class="">职位名称</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="">职位类别</div>
                            </el-col>
                            <el-col :span="6">
                                <div class="">工作城市</div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="sfq">
                        <el-collapse v-model="joinName" accordion>
                            <el-collapse-item v-for="(item,i) in joinList" :key="item.joinUsId" :name="i">
                                <template slot="title">
                                    <el-row>
                                        <el-col :span="8">
                                            <div class="mt">&nbsp;&nbsp;&nbsp;&nbsp;{{item.jobName}}</div>
                                        </el-col>
                                        <el-col :span="8">
                                            <div class="mt">&nbsp;&nbsp;&nbsp;&nbsp;{{item.jobStyle}}</div>
                                        </el-col>
                                        <el-col :span="6">
                                            <div class="mt">&nbsp;&nbsp;&nbsp;&nbsp;{{item.city}}</div>
                                        </el-col>
                                    </el-row>
                                </template>
                                <div class="responsibility">
                                    <el-row>
                                        <el-col :span="3">
                                            <div class="">岗位职责：</div>
                                        </el-col>
                                        <el-col :span="21">
                                            <div class="">
                                                <p v-for="(json, i) in item.jobStatement" :key="i" style="white-space: pre;">{{json}}</p>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </div>
                                <div class="require">
                                    <el-row>
                                        <el-col :span="3">
                                            <div class="">岗位要求：</div>
                                        </el-col>
                                        <el-col :span="21">
                                            <div class="">
                                                <p v-for="(json, i) in item.jobRequirement" :key="i" style="white-space: pre;">{{json}}</p>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                </el-tab-pane>

                <el-tab-pane label="联系我们" name="lxwm" class="relation">
                    <el-row class="line">
                        <el-col :span="2">
                            <div class="lxPic"><img src="../assets/img/about－image－24.png" alt=""></div>
                        </el-col>
                        <el-col :span="4">
                            <div class="jian">
                                <span>售前支持：</span>
                            </div>
                        </el-col>
                        <el-col :span="18">
                            <div class="zhi">
                                400-777-1147
                            </div>
                        </el-col>
                    </el-row>

                    <el-row class="line">
                        <el-col :span="2">
                            <div class="lxPic"><img src="../assets/img/about－image－25.png" alt=""></div>
                        </el-col>
                        <el-col :span="4">
                            <div class="jian">
                                <p>商务支持：</p>
                                <!-- <p>品牌合作：</p> -->
                                <p>顾问服务：</p>
                            </div>
                        </el-col>
                        <el-col :span="18">
                            <div class="zhi">
                                <p>chengxie@orancrab.com</p>
                                <!-- <p>yanyi@orancrab.com</p> -->
                                <p>chenzhan@orancrab.com</p>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row class="line">
                        <el-col :span="2">
                            <div class="lxPic"><img src="../assets/img/about－image－26.png" alt=""></div>
                        </el-col>
                        <el-col :span="4">
                            <div class="jian">
                                <p>视频号：</p>
                            </div>
                        </el-col>
                        <el-col :span="18">
                            <div class="zhi">
								<div class="WeCHat">
									<img src="../assets/img/about-image-cx.png" alt="" style="width:99px;height:99px">
                                    <!-- <p style="text-align:center">橙蟹(订阅号)</p> -->
                                </div>
								<div class="WeCHat">
                                    <img src="../assets/img/about-image-cxyc.png" alt="" style="width:99px;height:99px">
                                    <!-- <p style="text-align:center">橙蟹(订阅号)</p> -->
                                </div>

                            </div>
                        </el-col>
                    </el-row>

                    <el-row class="line">
                        <el-col :span="2">
                            <div class="lxPic"><img src="../assets/img/about－image－27.png" alt=""></div>
                        </el-col>
                        <el-col :span="4">
                            <div class="jian">
                                <p>官方运营号：</p>
                            </div>
                        </el-col>
                        <el-col :span="18">
                            <div class="zhi">
                                <div class="WeCHat">
                                    <img src="../assets/img/home－image－cx.png" alt="">
                                    <p style="text-align:center">橙蟹(订阅号)</p>
                                </div>
                                <div class="WeCHat" style="margin-left:10px">
                                    <img src="../assets/img/home－image－cxyc.jpg" alt="">
                                    <p style="text-align:center">橙蟹有才(服务号)</p>
                                </div>
								<div class="WeCHat" style="margin-left:10px">
                                    <img src="../assets/img/image-cxqf.jpg" alt="">
                                    <p style="text-align:center">橙蟹企服</p>
                                </div>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row class="line">
                        <el-col :span="2">
                            <div class="lxPic"><img src="../assets/img/about－image－28.png" alt=""></div>
                        </el-col>
                        <el-col :span="4">
                            <div class="jian">
                                <p>深圳总部：</p>
                            </div>
							<div class="jian">
                                <p>服务热线：</p>
                            </div>
                        </el-col>
                        <el-col :span="18">
                            <div class="zhi">
                                <p>广东省深圳市宝安区宝源路名优工业产品展示采购中心B座B738</p>
                            </div>
							<div class="zhi">（0755）27207990</div>
                        </el-col>
                    </el-row>
					<el-row class="line">
                        <el-col :span="4" :offset="2">
                            <div class="jian">
                                <p>广州分部：</p>
                            </div>
                        </el-col>
                        <el-col :span="18">
                            <div class="zhi">
                                <p>广东省广州市天河区珠江东路28号越秀金融大厦65楼105室</p>
                            </div>
                        </el-col>
                    </el-row>
					<el-row class="line">
                        <el-col :span="4" :offset="2">
                            <div class="jian">
                                <p>武汉分部：</p>
                            </div>
                        </el-col>
                        <el-col :span="18">
                            <div class="zhi">
                                <p>湖北省武汉市江汉区建设大道568号新世界国贸大厦36楼AD36</p>
                            </div>
                        </el-col>
                    </el-row>

					<el-row class="line">
                        <el-col :span="4" :offset="2">
                            <div class="jian">
                                <p>光明分部：</p>
                            </div>
                        </el-col>
                        <el-col :span="18">
                            <div class="zhi">
                                <p>广东省深圳市光明区凤凰街道东坑社区科能路中集低轨卫星物联网产业园F座408</p>
                            </div>
                        </el-col>
                    </el-row>
					<el-row class="line">
                        <el-col :span="4" :offset="2">
                            <div class="jian">
                                <p>襄阳分部：</p>
                            </div>
                        </el-col>
                        <el-col :span="18">
                            <div class="zhi">
                                <p>湖北省襄阳市襄州区航空路民发世界城都会山28-A2202-2205 </p>
                            </div>
                        </el-col>
                    </el-row>
					<el-row class="line">
                        <el-col :span="4" :offset="2">
                            <div class="jian">
                                <p>深圳分部：</p>
                            </div>
                        </el-col>
                        <el-col :span="18">
                            <div class="zhi">
                                <p>广东省深圳市福田区深业上城小镇南区LOFTB 4层</p>
                            </div>
                        </el-col>
                    </el-row>
					<el-row class="line">
                        <el-col :span="4" :offset="2">
                            <div class="jian">
                                <p>重庆分部：</p>
                            </div>
                        </el-col>
                        <el-col :span="18">
                            <div class="zhi">
                                <p>重庆市渝中区邹容路68号大都会商厦3755室</p>
                            </div>
                        </el-col>
                    </el-row>
					<el-row class="line">
                        <el-col :span="4" :offset="2">
                            <div class="jian">
                                <p>前海分部：</p>
                            </div>
                        </el-col>
                        <el-col :span="18">
                            <div class="zhi">
                                <p>广东省深圳市南山区前海深港合作区金融街2号前海大厦T2栋4层</p>
                            </div>
                        </el-col>
                    </el-row>
					<el-row class="line">
                        <el-col :span="4" :offset="2">
                            <div class="jian">
                                <p>白云分部：</p>
                            </div>
                        </el-col>
                        <el-col :span="18">
                            <div class="zhi">
                                <p>广东省广州市白云区白云大道南295号3楼319-234室</p>
                            </div>
                        </el-col>
                    </el-row>
                </el-tab-pane>
            </el-tabs>
        </main>
    </div>
</template>

<script>
import { companyNews, joingetPageList } from '../api/api.js'
export default {
  name: 'aboutUs',
  created () {
    this.activeName = this.$route.params.tab
    companyNews({ isFore: 1 }).then(res => {
      this.informationList = res.data.data.list
      this.paging = res.data.data
    })
    joingetPageList().then(res => {
      //   this.joinList = res.data.data.list;
      for (let i = 0; i < res.data.data.list.length; i++) {
        if (res.data.data.list[i].joinUsStatus == '1') {
          this.joinList.push(res.data.data.list[i])
        }
      }
      for (let i = 0; i < this.joinList.length; i++) {
        this.joinList[i].jobRequirement = this.joinList[i].jobRequirement.split('；')
        this.joinList[i].jobStatement = this.joinList[i].jobStatement.split('；')
      }
    })
  },
  data () {
    return {
      activeName: 'cxjj',
      url: 'http://121.40.191.9' + this.GLOBAL.picURL,
      joinName: [0],
      praiseList: [
        {
          imgPath: require('../assets/img/about－image－7.png'),
          word: '我们一直选择橙蟹提供的财务管理服务，帮我们从最基础的财务流水账建设到完善的财务核算体系，实现了从业务端到财务端的系统化管理，同时也为我们申请高新技术企业打下了坚实的基础。在公司发展阶段做出的许多重大决策时，橙蟹的专业服务都为我们提供了有利的帮助，让我们少走许多弯路。'
        },
        {
          imgPath: require('../assets/img/about－image－8.png'),
          word: '选择橙蟹是缘分，随着公司的成长，需要一家专业且高效、可靠的财务团队，橙蟹的团队成员均具备丰富的财务知识和实践经验，能够迅速应对各种复杂的财务问题，为企业提供专业的解决方案。他们注重与客户的沟通，定期汇报工作进度，及时解答客户疑问，确保信息透明、沟通顺畅。希望公司能在橙蟹的陪伴下一路茁壮成长！'
        },
        {
          imgPath: require('../assets/img/about－image－9.png'),
          word: '从创业初期就选择跟橙蟹合作至今，最初是因为想要一种全新的尝试，那就是将财务部直接进行外包，在多年的实践看来，我们的选择是对的，除了在成本上得到了节约，更重要的是橙蟹专业的团队让我们在一轮又一轮的融资过程中，提供高质量的财务数据，得到了投资人的认可。'
        },
        {
          imgPath: require('../assets/img/about－image－10.png'),
          word: '从创业初期就选择跟橙蟹合作至今，最初是因为想要一种全新的尝试，那就是将财务部直接进行外包，在多年的实践看来，我们的选择是对的，除了在成本上得到了节约，更重要的是橙蟹专业的团队让我们在一轮又一轮的融资过程中，提供高质量的财务数据，得到了投资人的认可。'
        },
        {
          imgPath: require('../assets/img/about－image－11.png'),
          word: 'A轮融资后，我们有了招聘财务总监的想法，偶然的机会知道橙蟹有兼职财务总监的服务，于是我们做了大胆的尝试，橙蟹在伴随我们完成了B轮及B+轮的融资的同时，也提升了公司整体的财务管理水平，橙蟹的模式是一种创新，而于我们而言，也是一次成功的尝试。'
        },
        {
          imgPath: require('../assets/img/about－image－12.png'),
          word: '作为一家FA机构，我们保持着对新商业模式的探索欲，橙蟹的财务外包让我们看到一种全新的财务服务方式，在经过多年的合作后我们确定，企业与企业的同步成长会更容易一些，也会更同频。'
        },

        {
          imgPath: require('../assets/img/about－image－13.png'),
          word: '因为个人的海外留学经历，一直认可财务外包的形式，得知橙蟹有财务外包服务后，果断选择，一方面降低了公司的财务成本，另一方面我们获得了专业的财务服务，对于我们这种专业需求高但是工作量不大的研发类企业，非常的合适。'
        },
        {
          imgPath: require('../assets/img/about－image－14.png'),
          word: '我们工厂创建初期，在管理和人员配置还不够齐全的情况下，橙蟹的财务到家服务正好服务我们的需求；随着工厂的发展，我们又选择报表易服务，橙蟹用他们的专业优势，帮我们搭建财务团队，完善财务核算及管理制度，陪伴我们稳步发展。非常感谢橙蟹'
        },
        {
          imgPath: require('../assets/img/about－image－15.png'),
          word: '我们选择橙蟹的财务到家服务，满足我们初创企业的财务服务需求；橙蟹顾问团队周到耐心的服务，精细的财务核算，每月一次的财务分析会议，给我们公司经营管理起到非常大的帮助！'
        },

        {
          imgPath: require('../assets/img/about－image－16.png'),
          word: '我们选择橙蟹的报表易服务，帮助我们搭建核算体系，税务合规体系，财务管理制度。降低了税务风险，减少了管理漏洞，让我们各校区的财务核算更加清晰，管理流程更加流畅，使各校区店长的经营管理有了方向盘和仪表盘。'
        },
        {
          imgPath: require('../assets/img/about－image－17.png'),
          word: '橙蟹给我们提供非常专业的财务服务，在这之前我们没有清晰的账务数据，自从和橙蟹合作以后，公司的财务数据非常清晰，梳理了工作流程使财务部工作更简化，并且对资金风险的监控、股权的设计、企业管理等方面提供了有效的帮助，企业快速发展过程中，橙蟹是最靠谱的选择，不仅节约人力成本，还有综合型财务人员提供服务'
        },
        {
          imgPath: require('../assets/img/about－image－18.png'),
          word: '我们选择橙蟹作为财务外包服务商，他们利用专业能力，深入企业业务运营管理，发现管理中的漏洞，用数据量化问题，并提出改善建议，让企业避免损失，体现财务价值。同时橙蟹服务为团队服务，能从全局上为企业做财务规划，这些都是中小企业所需要，而且适合我们的。'
        },
        {
          imgPath: require('../assets/img/about－image－19.png'),
          word: '橙蟹十分专业，协助我们公司利用信息技术搭建财务体系，从制订标准的财务核算流程，建立有效的沟通机制，到完善财务制度和政策。并在此过程中不停的强化对我们公司财务人员的培训，提高大家对风险的识别和规范全过程管理能力。'
        },
        {
          imgPath: require('../assets/img/about－image－20.png'),
          word: '橙蟹给我们提供的财务到家服务，每月上门服务后及时核对账目情况，和橙蟹合作以来，公司的账务数据逐步完善，非常清晰，每月及时申报不用操心，不同于传统的财务代账，省钱、省心、快捷。！'
        },
        {
          imgPath: require('../assets/img/about－image－21.png'),
          word: '这几年公司发展比较快，正在处于扩张阶段，而财务是否专业也成为经营中不得不考虑的因素了，基于公司的实际情况，我们选择了与橙蟹合作，在这个过程中，橙蟹省心的服务以及顾问的专业都是我们所需要的，从绩效考核方案到股权激励，橙蟹为我们搭建了一个很好的体系，也让我们财务人员得到了很好的成长。'
        }
      ],
      joinList: [],
      informationList: [],
      paging: []
    }
  },
  watch: {
    '$route': 'getPath'
  },
  methods: {
    getPath () {
      this.activeName = this.$route.params.tab
    },
    handleClick (tab, event) {},
    handleCurrentChange (val) {
      companyNews({
        pageNum: val,
        isFore: 1
      }).then(res => {
        this.informationList = res.data.data.list
        this.paging = res.data.data
      })
    },
    prevClickChange (val) {
      companyNews({
        pageNum: val,
        isFore: 1
      }).then(res => {
        this.informationList = res.data.data.list
        this.paging = res.data.data
      })
    },
    nextClickChange (val) {
      companyNews({
        pageNum: val,
        isFore: 1
      }).then(res => {
        this.informationList = res.data.data.list
        this.paging = res.data.data
      })
    },
    jump (id) {
      this.$router.push({ path: '/companyNewsDetail/' + id + '/2' })
    }
  }
}
</script>

<style scoped>
    /* 图片 */
    .pic {
        width: 100%;
        height: 30%;
        text-align: center;
    }

    .pic img {
        width: 100%;
    }

    .pic p {
        font-size: 34px;
        color: #ffffff;
        margin-top: -12%;
        margin-left: 37%;
    }

    /* 主体内容 */
    .aboutUs .aboutUs-main {
        width: 70%;
        padding: 0 15%;
        background-color: #f5f5f5;
        position: relative;
        color: #2d3557;
    }

    /* 简介 */
    .intro,
    .advantage,
    .information,
    .join,
    .relation {
        padding: 0 6%;
    }

    .intro h3 {
        text-align: center;
        font-weight: 900;
        font-size: 16px;
        padding: 2% 0;
    }

    .intro p {
        text-indent: 2em;
        padding: 6px 0;
        font-size: 16px;
    }

    .bigNew {
        margin: 3% 0;
        padding: 0 3%;
    }

    .bigNew img {
        width: 100%;
    }

    .culture {
        margin-top: 2%;
    }

    .culture div {
        display: inline-block;
        width: 46%;
        padding: 3% 0;
        margin-left: 2%;
        margin-bottom: 2%;
        text-align: center;
        background-color: #2d3557;
        color: #ffffff;
    }

    .bgIntro div {
        display: inline-block;
        width: 31.33333%;
        margin: 2% 0 6% 1%;
    }

    /* 优势 */
    .advantage h2 {
        text-align: center;
        font-size: 32px;
        margin: 3% 0;
    }

    h2 p {
        font-size: 16px;
        font-weight: normal;
    }

    .selectCX div {
        display: inline-block;
        width: 48%;
    }

    .selectCX .word {
        padding: 4% 0;
        /* font-size: 16px; */
    }

    .word h3 {
        font-size: 32px;
        margin-bottom: 1%;
    }

    .selectCX img {
        width: 100%;
    }

    .jyPic img {
        width: 100%;
    }

    .praise .praiseBox {
        /* display: inline-block; */
        height: 594px;
        margin-left: 4%;
    }

    .praise img {
        width: 100%;
    }

    .praise p {
        /* padding-right: 20%; */
    }

    /* 企业资讯 */
    .information-row {
        margin-bottom: 3%;
    }

    .information-row-img img {
        width: 100%;
    }

    .rel {
        padding: 1% 0 1% 2%;
    }

    .information-row-word h4 {
        padding: 1%;
        font-size: 16px;
    }

    .information-row-word p {
        padding: 1%;
    }

    /* 加入我们 */
    .join .formTop {
        background-color: #2d3557;
        color: #ffffff;
        padding: 1% 1%;
    }

    .mt {
        /* padding: 1% 1%; */
    }

    .join h2 {
        text-align: center;
        padding: 2% 0;
    }

    .responsibility,
    .require {
        padding: 1% 2%;
    }

    /* 联系我们 */
    .line {
        margin-bottom: 2%;
    }

    .jian {
        padding: 8% 0;
    }

    .zhi {
        padding: 2% 0;
    }

    .zhi .WeCHat {
        display: inline-block;
        font-size: 12px;
    }

    .dt img {
        width: 100%;
    }
</style>
<style>
    .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
        color: rgba(255, 81, 18)
    }

    .el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover {
        color: rgba(255, 81, 18)
    }
</style>



// WEBPACK FOOTER //
// src/components/aboutUs.vue